<template>
  <v-layout class="inner-pages" column >
    <Header />

    <scroll-data :footer="false">
      <Programs62 v-if="gameId === 62 || gameId === 69"/>
      <Programs68 v-if="gameId === 68"/>

    </scroll-data>

  </v-layout>
</template>

<script>
  import Programs from './Programs'
  import Programs62 from './Programs62'
  import Programs68 from './Programs68'
  import Header from '../../layouts/Header.vue'
  import ScrollData from '../../ScrollData.vue'

  export default {
    name: 'Programs',
    components: {Header, ScrollData, Programs, Programs62, Programs68},
    data () {
      return {
        gameId: process.env.GAME_ID
      }
    }
  }
  </script>




// WEBPACK FOOTER //
// src/components/views/Programs/Index.vue